import React, { PureComponent } from "react";
class EmptyDialogue extends PureComponent {
  render() {
    return /*#__PURE__*/React.createElement("div", null);
  }
}
export default EmptyDialogue;